<template>
  <v-dialog
    v-model="visible"
    persistent
    max-width="520"
    content-class="funding-questionnaire-dialog"
  >
    <v-card class="rounded-lg overflow-hidden">
      <div class="dialog-header pa-6 text-center white--text">
        <v-icon size="56" color="white" class="mb-3">mdi-forum-outline</v-icon>
        <h2 class="text-h6 font-weight-bold mb-2">أسئلة بانتظار إجابتك</h2>
        <p class="text-body-2 mb-0" style="opacity: 0.95">
          يوجد {{ pendingCount }} {{ pendingCount === 1 ? "سؤال" : "أسئلة" }} في منتدى الوساطة
          تحتاج إلى إجابتك قبل متابعة العمل.
        </p>
      </div>

      <v-card-text class="pa-6 text-center">
        <p class="text-body-1 grey--text text--darken-2 mb-0">
          يرجى الانتقال إلى صفحة منتدى الوساطة، قراءة الأسئلة، وإضافة تعليقك/إجابتك
          على كل سؤال معلّم بـ "بانتظار إجابتك".
        </p>
      </v-card-text>

      <v-card-actions class="pa-6 pt-0 justify-center">
        <v-btn
          color="primary"
          large
          depressed
          class="px-8 font-weight-bold"
          @click="goToQuestions"
        >
          <v-icon left>mdi-arrow-left</v-icon>
          الذهاب إلى الأسئلة
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "FundingQuestionnaireRequiredDialog",
  computed: {
    visible: {
      get() {
        return this.$store.state.showFundingQuestionnaireRequiredAlert;
      },
      set(value) {
        this.$store.state.showFundingQuestionnaireRequiredAlert = value;
      },
    },
    pendingCount() {
      return this.$store.state.pendingQuestionnaireCount || 0;
    },
  },
  methods: {
    goToQuestions() {
      this.visible = false;
      if (this.$route.name !== "FundingQuestionAndAnswer") {
        this.$router.push({
          name: "FundingQuestionAndAnswer",
          query: { required: "1" },
        });
      }
    },
  },
};
</script>

<style scoped>
.dialog-header {
  background: linear-gradient(135deg, #3f0e40 0%, #6a1b9a 100%);
}
</style>
